import Debouncer from '../lib/Debouncer';

export default class AnimationsClouds {
	private height: number = document.documentElement.scrollHeight;
	private background: HTMLElement = document.querySelector('.cloud--background');
	private foreground: HTMLElement = document.querySelector('.cloud--foreground');
	private parallaxRatio : number = .75;
	private scrollMultiplier : number = .05;

	constructor() {
		this.foreground.style.minWidth = this.background.style.minWidth = this.height + 'px';

		const scrollDebouncer = new Debouncer(() => {
			this.background.style.transform = 'translateX(-' + window.scrollY * this.scrollMultiplier * this.parallaxRatio + 'px)';
			this.foreground.style.transform = 'translateX(-' + window.scrollY * this.scrollMultiplier + 'px)';
		});


		window.addEventListener('scroll', scrollDebouncer.run);
	}
}
